import React from 'react';
import { useMatch, useParams } from 'react-router-dom';
import RoutePath from '@/Routing/RoutePath';
import useRecruitmentSpec from '../../api/useRecruitmentSpec';
import CandidatesOverviewNavigationSidebar from '@/Components/CandidatesOverview/CandidatesOverviewNavigationSidebar';

const AiSearchNavigationSidebar = () => {
    const { data } = useRecruitmentSpec();

    const isAgenticSearchSelected = !!useMatch(RoutePath.AgenticAiSearch);
    const isIdentifiedAiSearchSelected = !!useMatch(RoutePath.IdentifiedAiSearch);
    const isShortlistedAiSearchSelected = !!useMatch(RoutePath.ShortlistedAiSearch);
    const params = useParams();
    const assessmentId = params.assessmentId || '';
    const companyId = params.companyId || '';
    const clientId = data?.clientId || '';

    return (
        <CandidatesOverviewNavigationSidebar
            assessmentId={assessmentId}
            clientId={clientId}
            companyId={companyId}
            isAgenticSearchSelected={isAgenticSearchSelected}
            isIdentifiedAiSearchSelected={isIdentifiedAiSearchSelected}
            isShortlistedAiSearchSelected={isShortlistedAiSearchSelected}
        />
    );
};

export default AiSearchNavigationSidebar;
